import { createRequest, titanApi } from "./titanApi";

const extendedApi = titanApi.enhanceEndpoints({}).injectEndpoints({
  endpoints: (builder) => ({
    sendNewPassword: builder.mutation({
      query: (token) => ({
        ...createRequest(`/api/users/setNewPassword`),
        method: "POST",
        body: { ...token },
      }),
    }),

    resetPassword: builder.mutation({
      query: (username) => ({
        ...createRequest(`/api/users/resetPassword`),
        method: "POST",
        body: { ...username },
      }),
    }),
  }),

  // https://redux-toolkit.js.org/rtk-query/usage/code-splitting
  overrideExisting: false,
});

export const { useSendNewPasswordMutation, useResetPasswordMutation } = extendedApi;
